<app-selection-list [config-object]="configChange()" />
